/**
 * Shared auto-scroll timing for Magio continuous marquees.
 * Seconds per slide width — higher = slower (4–30s, default 12s).
 */
(function (g) {
  var MIN_SEC = 4;
  var MAX_SEC = 30;
  var DEFAULT_SEC = 12;

  function clampSeconds(value) {
    var n = parseFloat(value);
    if (!isFinite(n)) n = DEFAULT_SEC;
    return Math.min(MAX_SEC, Math.max(MIN_SEC, n));
  }

  function pixelsPerSecond(slideWidthPx, seconds) {
    var sec = clampSeconds(seconds);
    if (slideWidthPx <= 0 || sec <= 0) return 0;
    return slideWidthPx / sec;
  }

  g.MagioAutoscroll = {
    MIN_SEC: MIN_SEC,
    MAX_SEC: MAX_SEC,
    DEFAULT_SEC: DEFAULT_SEC,
    clampSeconds: clampSeconds,
    pixelsPerSecond: pixelsPerSecond
  };
})(typeof window !== 'undefined' ? window : this);
